import { useState } from 'react';
import { Controller, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AvailableToIdsPopover } from './available-to-ids-popover';

import type { AvailableToSelectFieldProps } from '@/types/predefined-messages';

import { FieldLabel } from '@/components/ui/field';
import { usePredefinedMessageFormHelpers } from '@/lib/helpers/predefined-messages';

export function AvailableToSelectField({
  control,
  availableToTargets,
  availableToError,
}: AvailableToSelectFieldProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { getAvailableToSummary } = usePredefinedMessageFormHelpers();
  const availableToIds = useWatch({ control, name: 'availableToIds' }) ?? [];
  const availableToSummary = getAvailableToSummary({ availableToIds, availableToTargets });

  return (
    <div className="space-y-2">
      <FieldLabel className="text-sm font-medium" required>
        {t('configuration.predefinedMessages.columns.availableTo')}
      </FieldLabel>
      <Controller
        name="availableToIds"
        control={control}
        render={({ field: { value, onChange } }) => (
          <AvailableToIdsPopover
            value={value}
            onChange={onChange}
            open={open}
            onOpenChange={setOpen}
            availableToTargets={availableToTargets}
            summary={availableToSummary}
          />
        )}
      />
      {availableToError && (
        <p className="text-destructive text-xs" role="alert">
          {availableToError.message}
        </p>
      )}
    </div>
  );
}
